import * as React from "react";

export const Wrapper = ({ children, className }) => (
  <div
    className={`bg white rounded border-slate-100 border border-solid shadow-sm text-gray-500 inline-flex flex-col p-3 ${className}`}
  >
    {children}
  </div>
);
